import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Clock, X } from "lucide-react";
import { getRecentSearches, clearRecentSearches } from "../../lib/userHistory";
import { SectionHeader } from "./SectionHeader";

export const BasedOnYou = () => {
  const [recent, setRecent] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    setRecent(getRecentSearches());
  }, []);

  if (!recent.length) return null;

  const onClear = () => {
    clearRecentSearches();
    setRecent([]);
  };

  return (
    <section data-testid="home-based-on-you" className="mt-12 sm:mt-16">
      <SectionHeader
        icon={Clock}
        eyebrow="Based on your searches"
        title="Pick up where you left off"
        action={
          <button
            onClick={onClear}
            data-testid="home-clear-history"
            className="hidden sm:inline-flex items-center gap-1 text-[11px] text-muted-foreground hover:text-foreground transition"
          >
            <X className="w-3 h-3" /> Clear history
          </button>
        }
      />
      <div className="flex flex-wrap gap-2.5">
        {recent.map((r, i) => (
          <button
            key={`${r.query}-${i}`}
            onClick={() => navigate("/chat", { state: { initial: r.query } })}
            data-testid={`home-recent-${i}`}
            className="text-xs sm:text-sm px-4 py-2 rounded-full bg-emerald-500/5 border border-emerald-500/30 text-foreground/90 hover:bg-emerald-500/10 hover:border-emerald-500/50 transition flex items-center gap-2"
          >
            <Clock className="w-3 h-3 text-emerald-500/80" />
            {r.query}
          </button>
        ))}
      </div>
    </section>
  );
};

export default BasedOnYou;
